"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.mediaOnly = exports.mediaMin = exports.mediaMax = exports.media = void 0;
var _warning = _interopRequireDefault(require("warning"));
var _get = _interopRequireDefault(require("lodash/get"));
var media = exports.media = function media(condition, size) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  return function (props) {
    var conditionValue = typeof condition === 'function' ? condition(props) : condition;
    var queryGroup = (0, _get.default)(props, "theme.media." + conditionValue);
    var hasQueryGroup = queryGroup != null;
    (0, _warning.default)(hasQueryGroup, "[media] Non-existing query condition '" + conditionValue + "' provided.");
    if (hasQueryGroup) {
      var sizeValue = typeof size === 'function' ? size(props) : size;
      var query = queryGroup[sizeValue];
      var hasQuery = query != null;
      (0, _warning.default)(hasQuery, "[media] Non-existing query '" + conditionValue + "." + sizeValue + "' provided.");
      if (hasQuery) {
        return query.apply(void 0, args.map(function (arg) {
          return typeof arg === 'function' ? arg(props) : args;
        }));
      }
    }
    return undefined;
  };
};
var mediaMin = exports.mediaMin = function mediaMin(size) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }
  return media.apply(void 0, ['min', size].concat(args));
};
var mediaMax = exports.mediaMax = function mediaMax(size) {
  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }
  return media.apply(void 0, ['max', size].concat(args));
};
var mediaOnly = exports.mediaOnly = function mediaOnly(size) {
  for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }
  return media.apply(void 0, ['only', size].concat(args));
};